module.exports = __webpack_public_path__ + "components/country-flag/static/bv-6ed96e16fcf5054afc3059430e8de660.svg";